<template>
  <header class="top-toolbar flex md:grid md:grid-cols-3 items-center h-14 px-4 gap-4 shrink-0">
    <div class="min-w-0 flex-1 flex items-center gap-2">
      <button
        type="button"
        class="md:hidden flex items-center justify-center w-10 h-10 rounded-full text-surface-400 hover:bg-surface-100 hover:text-primary-500 transition-colors cursor-pointer bg-transparent border-none p-0 shrink-0"
        @click="openMenu"
        aria-label="Open menu"
      >
        <Menu class="shrink-0 text-xl text-current" :size="24" aria-hidden="true" />
      </button>
      <h1 class="font-light text-surface-400 truncate min-w-0">
        {{ pageTitle }}
      </h1>
    </div>
    <div class="flex-1"></div>
    <!-- <div class="hidden md:flex justify-center min-w-0">
      <IconField>
        <InputIcon class="pi pi-search" />
        <InputText v-model="searchQuery" placeholder="Search..." class="w-64" type="search" />
      </IconField>
    </div> -->
    <div class="min-w-0 shrink-0 flex items-center justify-end">
      <UserMenu />
    </div>
  </header>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { Menu } from 'lucide-vue-next';
import UserMenu from '@/modules/auth/UserMenu.vue';
import { useMenuExpanded } from '@/composables/useMenuExpanded';

const route = useRoute();
const menuExpanded = useMenuExpanded();

function openMenu() {
  menuExpanded.value = true;
}

const pageTitle = computed(() => {
  const meta = route.meta as { title?: string };
  if (meta?.title) {
    return meta.title;
  }
  const pathToTitle: Record<string, string> = {
    '/': 'Products',
    '/usage': 'Usage',
    '/users': 'Users',
    '/api-settings': 'Settings',
    '/external-products': 'External Products',
    '/external-product-images': 'External Images',
    '/admin/users': 'Admin Users',
  };
  if (pathToTitle[route.path]) {
    return pathToTitle[route.path];
  }
  if (route.path.startsWith('/products/')) {
    return 'Product';
  }
  return 'Phottr';
});
</script>
